import React from 'react';
import { XIcon, PrinterIcon, EditIcon, CreditCardIcon } from 'lucide-react';
interface ViewTicketModalProps {
  onClose: () => void;
  onEdit: () => void;
  ticket: any;
  isLocked: boolean;
}
const ViewTicketModal: React.FC<ViewTicketModalProps> = ({
  onClose,
  onEdit,
  ticket,
  isLocked
}) => {
  if (!ticket) return null;
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center" data-id="element-508">
      <div className="relative bg-white rounded-lg shadow-xl max-w-3xl w-full mx-4" data-id="element-509">
        <div className="flex items-start justify-between p-4 border-b border-gray-200" data-id="element-510">
          <h3 className="text-xl font-semibold text-gray-900" data-id="element-511">
            Ticket Details
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500 focus:outline-none" aria-label="Close" data-id="element-512">
            <XIcon className="h-6 w-6" data-id="element-513" />
          </button>
        </div>
        <div className="p-6" data-id="element-514">
          <div className="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center mb-6 pb-4 border-b border-gray-200" data-id="element-515">
            <div data-id="element-516">
              <h4 className="text-lg font-medium text-gray-900" data-id="element-517">
                {ticket.airlineCode} - {ticket.ticketNumber}
              </h4>
              <p className="text-sm text-gray-600" data-id="element-518">{ticket.paxName}</p>
            </div>
            <div className="flex space-x-2 mt-3 sm:mt-0" data-id="element-519">
              {!isLocked && <button onClick={onEdit} className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-520">
                  <EditIcon className="h-4 w-4 mr-1" data-id="element-521" />
                  Edit
                </button>}
              <button className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" data-id="element-522">
                <PrinterIcon className="h-4 w-4 mr-1" data-id="element-523" />
                Print
              </button>
              {!ticket.reconciled && <button className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-green-700 bg-green-100 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500" data-id="element-524">
                  <CreditCardIcon className="h-4 w-4 mr-1" data-id="element-525" />
                  Reconcile
                </button>}
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-526">
            <div data-id="element-527">
              <h5 className="text-sm font-medium text-gray-700 mb-2" data-id="element-528">
                Ticket Information
              </h5>
              <div className="bg-gray-50 rounded-md p-4 space-y-3" data-id="element-529">
                <div className="flex justify-between" data-id="element-530">
                  <span className="text-sm text-gray-500" data-id="element-531">Ticket Number:</span>
                  <span className="text-sm font-medium" data-id="element-532">
                    {ticket.ticketNumber}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-533">
                  <span className="text-sm text-gray-500" data-id="element-534">Passenger Name:</span>
                  <span className="text-sm font-medium" data-id="element-535">{ticket.paxName}</span>
                </div>
                <div className="flex justify-between" data-id="element-536">
                  <span className="text-sm text-gray-500" data-id="element-537">Issue Date:</span>
                  <span className="text-sm font-medium" data-id="element-538">
                    {ticket.issueDate}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-539">
                  <span className="text-sm text-gray-500" data-id="element-540">Airline Code:</span>
                  <span className="text-sm font-medium" data-id="element-541">
                    {ticket.airlineCode}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-542">
                  <span className="text-sm text-gray-500" data-id="element-543">Class:</span>
                  <span className="text-sm font-medium" data-id="element-544">{ticket.class}</span>
                </div>
                <div className="flex justify-between" data-id="element-545">
                  <span className="text-sm text-gray-500" data-id="element-546">
                    Other Booking Ref:
                  </span>
                  <span className="text-sm font-medium" data-id="element-547">
                    {ticket.otherBkgRef || 'N/A'}
                  </span>
                </div>
              </div>
            </div>
            <div data-id="element-548">
              <h5 className="text-sm font-medium text-gray-700 mb-2" data-id="element-549">
                Sector & Pricing
              </h5>
              <div className="bg-gray-50 rounded-md p-4 space-y-3" data-id="element-550">
                <div className="flex justify-between" data-id="element-551">
                  <span className="text-sm text-gray-500" data-id="element-552">Sector:</span>
                  <span className="text-sm font-medium" data-id="element-553">{ticket.sector}</span>
                </div>
                <div className="flex justify-between" data-id="element-554">
                  <span className="text-sm text-gray-500" data-id="element-555">Sector Code:</span>
                  <span className="text-sm font-medium" data-id="element-556">
                    {ticket.sectorCode}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-557">
                  <span className="text-sm text-gray-500" data-id="element-558">Air Fare:</span>
                  <span className="text-sm font-medium" data-id="element-559">
                    ${ticket.airFare.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-560">
                  <span className="text-sm text-gray-500" data-id="element-561">Tax:</span>
                  <span className="text-sm font-medium" data-id="element-562">
                    ${ticket.tax.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between font-medium" data-id="element-563">
                  <span className="text-sm text-gray-500" data-id="element-564">Total Cost:</span>
                  <span className="text-sm" data-id="element-565">
                    ${ticket.totalCost.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-566">
                  <span className="text-sm text-gray-500" data-id="element-567">
                    Reconciliation Status:
                  </span>
                  <span className={`text-sm font-medium ${ticket.reconciled ? 'text-green-600' : 'text-red-600'}`} data-id="element-568">
                    {ticket.reconciled ? 'Reconciled' : 'Pending'}
                  </span>
                </div>
              </div>
            </div>
            <div className="md:col-span-2" data-id="element-569">
              <h5 className="text-sm font-medium text-gray-700 mb-2" data-id="element-570">
                Additional Information
              </h5>
              <div className="bg-gray-50 rounded-md p-4" data-id="element-571">
                <h6 className="text-sm font-medium mb-2" data-id="element-572">Remarks</h6>
                <p className="text-sm text-gray-600" data-id="element-573">
                  {ticket.remark || 'No remarks available for this ticket.'}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:px-6 flex justify-end border-t border-gray-200" data-id="element-574">
          <button type="button" onClick={onClose} className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:w-auto sm:text-sm" data-id="element-575">
            Close
          </button>
        </div>
      </div>
    </div>;
};
export default ViewTicketModal;